import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom"

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Form, { Checkbox, Input, InputNumber, Select } from '#Form'

export default function PromotionsEdit() {
	const api = useContext(APICtx)
	const { _id } = useParams()
	const [ categoriesOpts, setCategoriesOpts ] = useState([])
	const [ tradersOptions, setTraderOptions ] = useState([])
	const [ trader1, setTrader1 ] = useState(null)
	const [ trader2, setTrader2 ] = useState(null)
	const [ trader3, setTrader3 ] = useState(null)
	const [ trader4, setTrader4 ] = useState(null)
	const [ trader5, setTrader5 ] = useState(null)

	useEffect(() => {
		api.auth.usersAsOptions({ acl:'offers-trader' }).then(setTraderOptions)
		api.call('products-categories/options', { type:'platform' }).then(setCategoriesOpts)
	}, [])

	const title = (_id ? 'Modifica' : 'Crea') + ' promozione'
	const formDef = {
		_id,
		callSet: "promotions/set",
		callGet: _id && "promotions/get",
		idRedirect: _id => '/promotions/edit/'+_id,
		onLoad: data => {
			setTrader1(data.trader1)
			setTrader2(data.trader2)
			setTrader3(data.trader3)
			setTrader4(data.trader4)
			setTrader5(data.trader5)
		},
	}
	const tradersCount = [
		trader1,
		trader2,
		trader3,
		trader4,
		trader5,
	].filter(Boolean).length
	return (
		<Tpl title={title} backTo="/promotions">
			<Form {...formDef}>
				<Input label="Descrizione" name="label" required />
				<Select label="Categoria prodotti" name="productCategory" required options={categoriesOpts} emptyLabel="--- seleziona una categoria ---" />
				<Checkbox label="Applicare sulla vendita del nuovo?" name="saleNew" />
				<Checkbox label="Applicare sulla vendita dell'usato?" name="saleUsed" />
				<Checkbox label="Applicare sul noleggio giornaliero?" name="rentDaily" />
				<Checkbox label="Applicare sul noleggio mensile?" name="rentMonthly" />
				<InputNumber label="% sconto" name="discount" />
				
				<Select label="Commerciale" name="trader1" options={tradersOptions} emptyLabel="-- seleziona un commerciale --" onChange={setTrader1} />
				{ Boolean(tradersCount>0 || trader2) && <Select label="Commerciale" name="trader2" options={tradersOptions} emptyLabel="-- seleziona un commerciale --" onChange={setTrader2} /> }
				{ Boolean(tradersCount>1 || trader3) && <Select label="Commerciale" name="trader3" options={tradersOptions} emptyLabel="-- seleziona un commerciale --" onChange={setTrader3} /> }
				{ Boolean(tradersCount>2 || trader4) && <Select label="Commerciale" name="trader4" options={tradersOptions} emptyLabel="-- seleziona un commerciale --" onChange={setTrader4} /> }
				{ Boolean(tradersCount>3 || trader5) && <Select label="Commerciale" name="trader5" options={tradersOptions} emptyLabel="-- seleziona un commerciale --" onChange={setTrader5} /> }
			</Form>
		</Tpl>
	)
}
